// extracted by mini-css-extract-plugin
export default {"card":"l0-z","carouselContainer":"m0-z","carouselContent":"n0-z"};